import type { PageProps } from "@components/Pages/models/Pages";
import type ContextService from "@core-ui/ContextServices/ContextService";
import { createContext, type ReactElement, useContext } from "react";
import type PageDataContext from "../../logic/Context/PageDataContext";

export const PageDataContextContext = createContext<PageDataContext>(undefined);

class PageDataContextService implements ContextService {
	private _pageDataContextRef: { value: PageDataContext } = { value: null };

	Init({ children, pageProps }: { children: ReactElement; pageProps: PageProps }): ReactElement {
		return <PageDataContextContext.Provider value={pageProps.context}>{children}</PageDataContextContext.Provider>;
	}

	Provider({ children, value }: { children: ReactElement; value: PageDataContext }): ReactElement {
		return <PageDataContextContext.Provider value={value}>{children}</PageDataContextContext.Provider>;
	}

	get ref(): { value: PageDataContext } {
		return this._pageDataContextRef;
	}

	get value(): PageDataContext {
		return useContext(PageDataContextContext);
	}
}

export default new PageDataContextService();
